import { Box } from "@mui/material";
import type { Dispatch, FC, SetStateAction } from "react";
import type { DepartmentLocation } from "../../../../utils/models";
import { DepartmentLocations } from "./DepartmentLocations";
import type { GeneralFormData } from "./types";

export const LocationsTabContent: FC<{
	formData: GeneralFormData;
	setFormData: Dispatch<SetStateAction<GeneralFormData>>;
	isNewDept: boolean;
	existingDepartmentLocations: DepartmentLocation[];
	setExistingDepartmentLocations: Dispatch<SetStateAction<DepartmentLocation[]>>;
	newDepartmentLocations: DepartmentLocation[];
	setNewDepartmentLocations: Dispatch<SetStateAction<DepartmentLocation[]>>;
	setModifiedDepartmentLocations: Dispatch<SetStateAction<Set<string>>>;
	isUpdatingDepartmentLocations: boolean;
}> = ({
	isNewDept,
	existingDepartmentLocations,
	setExistingDepartmentLocations,
	newDepartmentLocations,
	setNewDepartmentLocations,
	setModifiedDepartmentLocations,
	isUpdatingDepartmentLocations,
}) => {
	return (
		<Box component="section" sx={{ display: "flex", flexDirection: "column", gap: "2rem", pb: 3 }}>
			{!isNewDept && (
				<DepartmentLocations
					existingDepartmentLocations={existingDepartmentLocations}
					setExistingDepartmentLocations={setExistingDepartmentLocations}
					newDepartmentLocations={newDepartmentLocations}
					setNewDepartmentLocations={setNewDepartmentLocations}
					setModifiedDepartmentLocations={setModifiedDepartmentLocations}
					isUpdatingDepartmentLocations={isUpdatingDepartmentLocations}
				/>
			)}
		</Box>
	);
};
